export default function createGlueframeTracking() {
	const ADB = window.mediaanalytics;
	const Media = ADB ? ADB.Media : null;
	const tracker = Media ? Media.getInstance() : null;
	const { adobeDataLayer } = window;
	const coverage = { '25': false, '50': false, '75': false };

	const videoProperties = function(Player, callback) {
		const video = {};

		const _ = {
			photo_id: 'video_photo_id',
			live_id: 'video_live_id',
			full_video: 'video',
			title: 'video_title',
			content: 'video_content',
			type: 'video_type',
			currentTime: 'currentTime',
			duration: 'duration',
			link: 'url',
			domain: 'domain',
			player_id: 'player_id',
			quality: 'quality',
			playing: 'playing',
			currentVideoEngagement: 'currentVideoEngagement',
			totalEngagement: 'totalEngagement',
			timeStart: 'timeStart',
			timeEnd: 'timeEnd',
			video_length: 'videoLenght'
		};

		Object.keys(_).forEach(key => {
			(function(item) {
				Player.get(_[item], function(value) {
					video[item] = value;
					delete _[item];
					if (Object.keys(_).length === 0) {
						video.id = video.live_id || video.photo_id;
						// eslint-disable-next-line
						console.log('video properties fetched', video);
						callback(video);
					}
				});
			})(key);
		});
	};

	const fireEvent = function(e) {
		// eslint-disable-next-line
		console.log('fireEvent', e);

		switch (e.event) {
			case 'loadeddata': {
				const { video } = e;
				const mediaName = video.title;
				const mediaId = video.id;
				const mediaLength = parseInt(video.duration, 10);
				const mediaObject = Media?.createMediaObject(
					mediaName,
					mediaId,
					mediaLength,
					Media.StreamType.VOD,
					Media.MediaType.Video
				);
				if (tracker) tracker.trackSessionStart(mediaObject);
				break;
			}
			case 'play':
				// eslint-disable-next-line no-unused-expressions
				tracker?.trackPlay();
				// eslint-disable-next-line no-unused-expressions
				adobeDataLayer?.push({
					event: 'videoPlayed',
					videoInfo: {
						videoPlayer: '23Video',
						...e.videoProps
					}
				});
				break;
			case 'pause':
				// eslint-disable-next-line no-unused-expressions
				tracker?.trackPause();
				// eslint-disable-next-line no-unused-expressions
				adobeDataLayer?.push({
					event: 'videoPaused',
					videoInfo: {
						videoPlayer: '23Video',
						...e.videoProps
					}
				});
				break;
			case 'ended':
				// eslint-disable-next-line no-unused-expressions
				tracker?.trackComplete();
				// eslint-disable-next-line no-unused-expressions
				tracker?.trackSessionEnd();
				// eslint-disable-next-line no-unused-expressions
				adobeDataLayer?.push({
					event: 'videoCompleted',
					videoInfo: {
						videoPlayer: '23Video',
						...e.videoProps
					}
				});
				break;
			case 'timeupdate':
				// eslint-disable-next-line no-case-declarations
				const percentCovered = Math.round(
					(+e.currentTime / +e?.videoProps?.duration) * 100
				).toString();
				// eslint-disable-next-line no-case-declarations
				const mileStones = Object.keys(coverage);
				if (
					percentCovered &&
					mileStones.includes(percentCovered.toString()) &&
					!coverage[percentCovered]
				) {
					coverage[percentCovered] = true;
					// eslint-disable-next-line no-unused-expressions
					adobeDataLayer?.push({
						event: 'videoUpdated',
						videoInfo: {
							videoPlayer: '23Video',
							percentCovered,
							...e.videoProps
						}
					});
				}
				// eslint-disable-next-line no-unused-expressions
				tracker?.updatePlayhead(e.currentTime);
				break;
			default:
				break;
		}
	};

	return function(_player) {
		const Player = _player;
		let videoProps;

		Player.bind('player:video:loaded', function() {
			videoProperties(Player, function(video) {
				videoProps = video;
				fireEvent({
					event: 'loadeddata',
					video,
					videoProps
				});
			});
		});

		// Listen for updates to currentTime
		Player.bind('player:video:timeupdate', function() {
			Player.get('currentTime', function(currentTime) {
				fireEvent({ event: 'timeupdate', currentTime, videoProps });
			});
		});

		// Ended
		Player.bind('player:video:ended', function() {
			fireEvent({
				event: 'ended',
				videoProps
			});
		});

		// Play/pause
		Player.bind('player:video:play player:video:pause', function(e) {
			const event = e === 'player:video:pause' ? 'pause' : 'play';
			fireEvent({
				event,
				videoProps
			});
		});
	};
}
